/**
 * DEAD SIGNAL — Chapter content contract (ADR-0001)
 *
 * A chapter module bundles the per-chapter content the engine renders, so the
 * engine stays single and only the active chapter's content is loaded (via a
 * dynamic import, which Vite emits as a separate chunk). The shared knowledge
 * plane (content/knowledge/), the full evidence record store, layer3Manifest,
 * and evidenceRegistry are cross-chapter and stay outside the chapter module.
 *
 * The contract grows by increment. Slots present today:
 *   id           number   loader key (1 = the playable demo slice)
 *   chapter      number   narrative chapter the slice belongs to (the demo is ch6)
 *   startSceneId string   scene the chapter opens in
 *   scenes       object   { sceneId: sceneDef } — each scene keeps its own
 *                         fields (hotspots, interview flag, chapter, etc.)
 *
 * Planned slots (added in later increments per .claude/plans/active/chapter-loader.md):
 *   sceneGraph, hotspotCoords, interviews, caseKnowledge, evidenceSeed,
 *   debriefObservations, hintChains + objective resolver, npcPersonas.
 */

/**
 * Throw if a chapter module does not satisfy the contract. Called by the loader
 * so a malformed chapter fails loudly at load instead of rendering an empty game.
 */
export function validateChapter(chapter) {
  if (!chapter || typeof chapter !== 'object') {
    throw new Error('[chapters] chapter module did not export a chapter object');
  }
  if (typeof chapter.id !== 'number') {
    throw new Error('[chapters] chapter is missing a numeric id');
  }
  if (typeof chapter.startSceneId !== 'string') {
    throw new Error(`[chapters] chapter ${chapter.id} is missing startSceneId`);
  }
  if (!chapter.scenes || typeof chapter.scenes !== 'object' || Object.keys(chapter.scenes).length === 0) {
    throw new Error(`[chapters] chapter ${chapter.id} has no scenes`);
  }
  if (!chapter.scenes[chapter.startSceneId]) {
    throw new Error(`[chapters] chapter ${chapter.id} startSceneId ${chapter.startSceneId} is not in scenes`);
  }
  return chapter;
}
